import { Input } from "reactstrap";
import { AsyncPaginatedSelect } from "components/common/AsyncPaginatedSelect";
import { getClientOptions } from "features/Clients/services/ClientService";
import {
  PettyWorkStatus,
  pettyWorkStatusMap,
} from "features/PettyWorks/constants/petty-work.constants";
import type { SelectOption } from "types/api.types";

export type PettyWorkListFiltersProps = {
  status: string;
  onStatusChange: (value: string) => void;
  clientId: number | null;
  onClientIdChange: (value: number | null) => void;
};

export default function PettyWorkListFilters({
  status,
  onStatusChange,
  clientId,
  onClientIdChange,
}: PettyWorkListFiltersProps) {
  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <Input
        type="select"
        className="form-select"
        style={{ width: 150 }}
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
      >
        <option value="">All statuses</option>
        {(Object.values(PettyWorkStatus) as PettyWorkStatus[]).map((s) => (
          <option key={s} value={s}>
            {pettyWorkStatusMap[s]?.label ?? s}
          </option>
        ))}
      </Input>
      <div style={{ width: 200 }}>
        <AsyncPaginatedSelect
          fetchOptions={getClientOptions}
          placeholder="Client…"
          value={clientId}
          onChange={(opt) =>
            onClientIdChange(
              opt && !Array.isArray(opt)
                ? Number((opt as SelectOption).value)
                : null,
            )
          }
        />
      </div>
    </div>
  );
}
